import { render } from "./InvitationReviewModal.vue.js?vue&type=template&id=a7c17b3a!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitationReviewModal.vue?vue&type=template&id=a7c17b3a"
import script from "./InvitationReviewModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitationReviewModal.vue?vue&type=script&lang=js"
export * from "./InvitationReviewModal.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitationReviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/InvitationReviewModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a7c17b3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a7c17b3a', __exports__)) {
    api.reload('a7c17b3a', __exports__)
  }
  
  module.hot.accept("./InvitationReviewModal.vue.js?vue&type=template&id=a7c17b3a!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitationReviewModal.vue?vue&type=template&id=a7c17b3a", () => {
    api.rerender('a7c17b3a', render)
  })

}


export default __exports__